import { render, staticRenderFns } from "./AuthorizedRouterLink.vue?vue&type=template&id=f0865f92"
import script from "./AuthorizedRouterLink.vue?vue&type=script&lang=js"
export * from "./AuthorizedRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports